import React from 'react';
import PropTypes from 'prop-types';

class NotFoundComponent extends React.Component {
    static displayName = 'NotFound';

    constructor(props) {
        super(props);
        if (props.staticContext) {
            props.staticContext.statusCode = 404;
        }
    }

    componentDidMount() {
        this.context.app.navigate(this.props.route);
    }

    render() {
        return <div />;
    }

    static contextTypes = {
        app: PropTypes.object
    };

    static defaultProps = {
        route: '/'
    };
}

NotFoundComponent.propTypes = {
    route: PropTypes.string
};

export default NotFoundComponent;
